import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { showNotification } from '../../StatusNotification';
import './securesubmissions.css';

/*
 * Lists encrypted form submissions for Staff/Admin. Shows metadata only —
 * sensitive values are never returned here, only on the detail view, which
 * decrypts server-side after re-checking the role.
 */
export class SecureSubmissions extends Component {
    static displayName = SecureSubmissions.name;

    constructor(props) {
        super(props);
        this.state = {
            submissions: [],
            ready: false,
            authorized: true
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    async getComponentData() {
        const response = await fetch('SecureSubmission/GetSubmissions', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });

        if (response.status === 401) {
            this.setState({ authorized: false, ready: true });
            return;
        }

        const data = await response.json();
        this.setState({ submissions: data, ready: true });
    }

    formatDate(value) {
        if (value == null) return '';
        let d = new Date(value);
        return isNaN(d) ? '' : d.toLocaleString();
    }

    render() {
        if (!this.state.ready) {
            return <div className='secure-submissions-container'><p>Loading...</p></div>;
        }

        if (!this.state.authorized) {
            return (
                <div className='secure-submissions-container'>
                    <div className='page-title'><h1>Secure Submissions</h1></div>
                    <p role='alert'>You do not have permission to view secure submissions. This area requires the Staff or Admin role.</p>
                </div>
            );
        }

        let rows = this.state.submissions.map((s) => (
            <tr key={s.id}>
                <td>{s.formName}</td>
                <td>{this.formatDate(s.timestamp)}</td>
                <td>{s.isPurged ? <span className='badge-purged'>Purged</span> : (s.submissionStatus || 'New')}</td>
                <td>{this.formatDate(s.completedDate)}</td>
                <td>
                    {s.isPurged
                        ? <span className='muted'>—</span>
                        : <Link to={'/SecureSubmissions/' + s.id} className='secure-view-link'>View</Link>}
                </td>
            </tr>
        ));

        return (
            <div className='secure-submissions-container'>
                <div className='page-title'><h1>Secure Submissions</h1></div>

                {this.state.submissions.length === 0
                    ? <p>No submissions found.</p>
                    : (
                        <table className='secure-submissions-table'>
                            <caption className='sr-only'>Encrypted form submissions</caption>
                            <thead>
                                <tr>
                                    <th scope='col'>Form</th>
                                    <th scope='col'>Submitted</th>
                                    <th scope='col'>Status</th>
                                    <th scope='col'>Completed</th>
                                    <th scope='col'>Action</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    )}
            </div>
        );
    }
}

export default SecureSubmissions;
